const number = {
  apply: (value) => {
    if (value === null || value === undefined || value === '') return '';
    return (value || '').replace(/\D/gi, '');
  },
  clean: (value) => {
    if (value === null || value === undefined || value === '') return '';
    return (value || '').replace(/\D/gi, '');
  },
};

export default number;
